import React, { useEffect, useState } from 'react'
import { Table, Space, Row, Col, Input, Pagination } from 'antd';
import { SearchOutlined } from '@ant-design/icons'
import logService from '../../../services/log-service';
import dayjs from 'dayjs';
import { changeDocumentTitle } from '../../../utils/title';

function Log() {
  const [logs, setLog] = useState([])
  const [filteredLog, setFilteredLog] = useState([])
  const [searchTerm, setSearchTerm] = useState()
  const [pagination, setPagination] = useState({ current: 1, total: 1, pageSize: 10 });
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Id",
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: "User",
      dataIndex: 'user',
      key: 'user',
      render: (user) => user?.email || '-',
    },
    {
      title: "Event",
      dataIndex: 'event',
      key: 'event',
    },
    {
      title: "Module",
      dataIndex: 'module',
      key: 'module',
      render: (text) => (
        <p>{text ? text : '-'}</p>
      ),
    },
    {
      title: "Identifier",
      dataIndex: 'message',
      key: 'message',
      render: (message) => <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', verticalAlign: 'bottom', }}
        dangerouslySetInnerHTML={{ __html: message }} />
    },
    {
      title: "Action Performed At",
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt) => {
        const specificDate = dayjs(createdAt); // Parse the created_at date
        return specificDate.format('YYYY-MM-DD HH:mm:ss'); // Format it as 'DD MMMM YYYY'
      },
    },
  ];

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    const filteredData = logs.filter((log) =>
      log.user?.email.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredLog(filteredData);
  };


  const initialize = async (page = 1, pageSize = pagination.pageSize) => {
    setLoading(true);
    const { success, data } = await logService.fetch(page);
    setLoading(false);
    if (success) {
      setLog(data.data);
      setFilteredLog(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  };

  useEffect(() => {
    changeDocumentTitle("Settings");
    initialize();
  }, [])

  return (
    <div style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: "#FFFFFF" }}>
      <Row gutter={30} style={{ padding: "5px", borderRadius: '4px' }} className='flex items-center'>
        <Col flex='auto' >
          <Space direction="horizontal" size={15} >
            <h5 className='font-bold'>Logs</h5>
          </Space>
        </Col>
        {/* <Col span={14} style={{ textAlign: "right" }} >
          <Input
            placeholder="Search"
            prefix={<SearchOutlined />}
            className="w-auto lg:w-2/5"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Col> */}
      </Row>
      <Table columns={columns} scroll={{ x: "max-content" }}
        loading={loading}
        dataSource={filteredLog}
        rowKey="id"
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page),
        //   showSizeChanger: false,
        // }}
        style={{ marginTop: '5px' }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  )
}
export default Log
